import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const invoiceNoteApi = createApi({
    reducerPath: "invoiceNoteApi",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["InvoiceNote"],
    endpoints: (builder) => ({

        // GET ALL NOTES
        getInvoiceNotes: builder.query({
            query: ({ type }) => ({
                url: `/admin/invoice-notes`,
                method: "GET",
                params: { type },
            }),
            providesTags: ["InvoiceNote"],
        }),

        // GET NOTE BY ID
        getInvoiceNoteById: builder.query({
            query: (id) => ({
                url: `/admin/invoice-note/${id}`,
                method: "GET",
            }),
            providesTags: ["InvoiceNote"],
        }),

        // ADD NOTE
        addInvoiceNote: builder.mutation({
            query: (data) => ({
                url: `/admin/invoice-note`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["InvoiceNote"],
        }),

        // UPDATE NOTE
        updateInvoiceNote: builder.mutation({
            query: ({ id, data }) => ({
                url: `/admin/invoice-note/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["InvoiceNote"],
        }),

        // DELETE NOTE
        deleteInvoiceNote: builder.mutation({
            query: (id) => ({
                url: `/admin/invoice-note/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["InvoiceNote"],
        }),

        // GET DEFAULT NOTE
        getDefaultInvoiceNote: builder.query({
            query: () => ({
                url: `/admin/invoice-note-default`,
                method: "GET",
            }),
            providesTags: ["InvoiceNote"],
        }),

    }),
});

export const {
    useGetInvoiceNotesQuery,
    useGetInvoiceNoteByIdQuery,
    useAddInvoiceNoteMutation,
    useUpdateInvoiceNoteMutation,
    useDeleteInvoiceNoteMutation,
    useGetDefaultInvoiceNoteQuery,
} = invoiceNoteApi;